import { createFileRoute, notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { setResponseStatus } from "@tanstack/react-start/server";

// Bilinmeyen URL'ler için 410 Gone döndüren splat (catch-all) route.
// Arama motorları 410'u "kalıcı kayıp" olarak işler; URL'i tekrar denemez ve
// indeksten 404'e göre çok daha hızlı düşürür. Bot/scraper trafiğini de azaltır.

const sendGone = createServerFn({ method: "GET" }).handler(async () => {
  setResponseStatus(410);
  return null;
});

export const Route = createFileRoute("/$")({
  loader: async () => {
    await sendGone();
    throw notFound();
  },
  // notFoundComponent zaten __root.tsx içinde tanımlı; markalı 404 sayfasını gösterir.
});
